import React, { useState, useEffect, useRef } from 'react';
import { useInterval } from 'react-use';

export const TrackInfo = ({audioDuration, isPlaying, track, title, onTrackClick, audioPlayer, audioPlayerIsLoading }) => {
    const [ audioPositionSeconds, setAudioPositionSeconds ] = useState(0);
    const [ audioPositionRelative, setAudioPositionRelative ] = useState(0);
    const refTrackData = useRef();

    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    const handleTrackClick = (event) => {
        let trackLength = document.getElementById('track-info').clientWidth;
        let trackPosition = event.nativeEvent.offsetX;
        let trackPositionSeconds = (trackPosition / trackLength) * audioDuration;

        if(audioPlayer){
            setAudioPositionSeconds(parseInt(trackPositionSeconds));
            audioPlayer.seek(trackPositionSeconds);
        }
    }

    useEffect(() => {
        setAudioPositionRelative(audioPositionSeconds / audioDuration);
    }, [audioPositionSeconds])

    useInterval(
        () => {
            if(audioPlayer){
                setAudioPositionSeconds(audioPlayer.seek());
            }
        },
        isPlaying ? 1000 : null
    );

    useEffect(() => {
        if (refTrackData.current) {
            setDimensions({
                width: refTrackData.current.offsetWidth,
                height: refTrackData.current.offsetHeight,
            });
        }
    }, [track]);

    return (
        <div id="track-info" className="track-info" onClick={handleTrackClick}>
            <div className={'track-info-position' + (audioPlayerIsLoading ? ' track-loading' : '')} style={{width: (audioPositionRelative * 100) + '%'}}></div>
            { audioPlayerIsLoading &&
                <span className="loading"></span>
            }
            {track &&
                <div className={'track-data' + (audioPlayerIsLoading ? ' track-loading' : '') + (dimensions?.width > 320 ? ' animate' : '')} ref={refTrackData}>
                    <div className="artist">{track.artist} - </div>
                    <div className="title">{track.title}</div>
                </div>
            }
        </div>
    );
}